import cx from 'classnames';
import styles from '../Table.module.scss';

type RowExtensionHeaderProps = {
  hasRowExtension: boolean;
};

const RowExtensionHeader = ({ hasRowExtension }: RowExtensionHeaderProps) => {
  if (!hasRowExtension) return null;

  return (
    <th
      className={cx({
        [styles.rowToggler]: true,
        [styles.sticky]: true,
        [styles.rowExtensionToggleColumn]: true,
      })}
    ></th>
  );
};

export default RowExtensionHeader;
